import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { ProjectWizardContext } from 'context/Context';
import { useContext } from 'react';

const currencyObj = {
  1: 'USD',
  2: 'ARS'
};

const thClassname = 'py-2';
const tdClassname = 'text-dark py-1';

const UnitsTable = ({ units }) => {
  const { types } = useContext(ProjectWizardContext);

  const propertyTypesOptions = [
    { value: 0, label: '-' },
    ...types.map(prop => ({
      value: prop.propertyType,
      label: prop.name,
      subtypes: prop?.subpropertyTypes?.map(sub => ({
        value: sub.id,
        label: sub.title
      }))
    }))
  ];

  const getLabelType = value => {
    const res =
      propertyTypesOptions.find(option => option.value === value) ||
      propertyTypesOptions[0];

    return res.label;
  };
  const getLabelSubType = unit => {
    const res = propertyTypesOptions[unit.property_type]?.subtypes?.find(
      subprop => subprop.value == unit.sub_property_type
    );
    return res?.label;
  };
  return (
    <Table className="fs--1 mb-0 overflow-hidden border-light table table-striped table-bordered bg-white rounded-3">
      <thead className="bg-200 text-nowrap align-middle">
        <tr>
          <th className={thClassname}>Unidad</th>
          <th className={thClassname}>Nombre</th>
          <th className={thClassname}>Estado</th>
          <th className={thClassname}>Tipo</th>
          <th className={thClassname}>Piso</th>
          <th className={thClassname}>Letra</th>
          <th className={thClassname}>Superficie total</th>
          <th className={thClassname}>Superficie cubierta</th>
          <th className={thClassname}>Ambientes</th>
          <th className={thClassname}>Baños</th>
          <th className={thClassname}>Toilettes</th>
          <th className={thClassname}>Precio</th>
          <th className={thClassname}>Expensas</th>
        </tr>
      </thead>

      <tbody>
        {units.map((unit, index) => {
          const status =
            unit.status && unit.status[0].toUpperCase() + unit.status.slice(1);

          return (
            <tr key={index} className="align-middle">
              <td className={tdClassname}>{index + 1}</td>
              <td className={tdClassname}>{unit.name || '-'}</td>
              <td className={tdClassname}>{status || '-'}</td>
              <td className={tdClassname}>
                {unit.sub_property_type && unit.sub_property_type !== '0'
                  ? getLabelType(unit.property_type) +
                    ' - ' +
                    getLabelSubType(unit)
                  : getLabelType(unit.property_type)}
              </td>
              <td className={tdClassname}>{unit.floor || '-'}</td>
              <td className={tdClassname}>{unit.number_letter || '-'}</td>
              <td className={tdClassname}>{unit.total_surface || '-'}</td>
              <td className={tdClassname}>{unit.covered_surface || '-'}</td>
              <td className={tdClassname}>{unit.ambience || '-'}</td>
              <td className={tdClassname}>{unit.bathrooms || '-'}</td>
              <td className={tdClassname}>{unit.toilettes || '-'}</td>
              <td className={tdClassname}>
                {unit.price
                  ? `${currencyObj[unit.currency]} ${unit.price}`
                  : '-'}
              </td>
              <td className={tdClassname}>
                {unit.expenses
                  ? `${currencyObj[unit.expenses_currency]} ${unit.expenses}`
                  : '-'}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

UnitsTable.propTypes = {
  units: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(['disponible', 'reservado', 'vendido', '']),
      floor: PropTypes.string,
      number_letter: PropTypes.string,
      ambience: PropTypes.number,
      covered_surface: PropTypes.number,
      total_surface: PropTypes.number,
      bathrooms: PropTypes.number,
      toilettes: PropTypes.number,
      currency: PropTypes.number,
      price: PropTypes.number,
      expenses_currency: PropTypes.number,
      expenses: PropTypes.number
    })
  )
};

export default UnitsTable;
